
import { FC } from "react";

import {
	LabelPosition,
	RHookFormNumberFieldWithLabel,
} from "@websential/cosmic-v20";

interface IFaderalLaborSponsoredFundsTaxCreditSetupFieldsPanel {}
export const FaderalLaborSponsoredFundsTaxCreditSetupFieldsPanel: FC<
	IFaderalLaborSponsoredFundsTaxCreditSetupFieldsPanel
> = ({}) => {
	return (
		<div>
			<RHookFormNumberFieldWithLabel
				id={"theFederalLaborSponsoredFundsTaxCreditIsTheLessorOf"}
				label="The federal labor sponsored funds tax credit is the lessor of"
				testId="The-federal-labor-sponsored-funds-tax-credit-is-the-lessor-of"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
				
			/>
			<RHookFormNumberFieldWithLabel
				id={"andOfTheApprovedSharePurchaseFederal"}
				label="and of the approved share puchase"
				testId="and-of-the-approved-share-puchase"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				id={"theProvincialLaborSponsoredFundsTaxCreditIsTheLessorOf"}
				label="The Provincial labor sponsored funds tax credit is the lessor of"
				testId="The-federal-labor-sponsored-funds-tax-credit-is-the-lessor-of"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				id={"andOfTheApprovedSharePurchaseProvincial"}
				label="and of the approved share puchase"
				testId="and-of-the-approved-share-puchase"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
		</div>
	);
};
